import ICONS from "../../../../../assets/Icons";
import BeneficiaryTransactionViewall from "../../../../../containers/Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const BeneTransactionStepConfirm = (props) => {
  const allLabels = [
    ...new Set([
      ...(props?.txnPayLoad?.labels || []),
      ...(props?.txnPayLoad?.ownerLabels || []),
    ]),
  ];

  return (
    <>
      {props?.showSimilarModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={"Similar transactions found"}
            headersubtext={
              "Transactions with similar details have already been created. Proceeding will result in a duplicate transaction."
            }
            isHeaderImgNeed={true}
            ShowIcon={ICONS.ALERT}
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => props?.setShowSimilarModal(false)}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            confirmbtnrequired={true}
            isbottomSectionneed={true}
            bottomHeaderTextNeed={true}
            btnText="Proceed with caution"
            handleFunction={() => {
              props?.setShowSimilarModal(false);
              props?.onForceCreate();
            }}
            bottomHeaderText={"Proceed with creating this transaction?"}
          >
            <BeneficiaryTransactionViewall
              bene_account_name={props?.txnPayLoad?.bankAccountName || "NA"}
              bene_account_id={props?.txnPayLoad?.beneAccountId || null}
              bene_account_confidential={
                props?.txnPayLoad?.beneAccountId || null
              }
              onClose={() => {
                props?.setShowSimilarModal(false);
              }}
              queryParams={props?.queryParams}
              similarTxnType={"similarTxn"}
              popup={"modalType"}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto ${props?.isReminderFlow && "mb-[var(--card-height)] Qsmd:mb-margin-base"}`}
      >
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="beneficiary"
            txnPayLoad={props.txnPayLoad}
            setTxnPayLoad={props.setTxnPayLoad}
            page="confirm"
          />
          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={props?.txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={props?.txnPayLoad?.settleType}
            />
          </div>

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={props?.isConfidential}
            isPreview={true}
          />

          <CategorySelector
            previewMode={true}
            selectedCategory={props?.txnPayLoad?.selectedCategory}
            category={props?.txnPayLoad?.mergeCategory || []}
            IFSC={props?.txnPayLoad?.bankAccountIFSC}
            accountNumber={props?.txnPayLoad?.bankAccountNo}
            beneAccountId={props?.txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />

          <div className="lg:max-w-[var(--create-box-width)] lg:w-width-full w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={props.txnPayLoad.mergeCategory}
              previewImages={props?.previewImages}
            />
          </div>

          <div className="w-width-full h-auto p-padding-md rounded-border-radius-md bg-primary-card">
            <p className="text-left text-base mb-margin-md text-text-primary">
              <span className="font-semibold">Labels</span>
              <span className="font-normal"> (Optional)</span>
            </p>

            <div className="w-width-full flex flex-col gap-gap-xs">
              <p className="text-text-primary text-font-md break-words lg:break-normal lg:whitespace-normal">
                {allLabels.length === GlobalConfiguration.lengthCheckZero ? (
                  <span>{globalText?.NO_LABELS_ASSIGNED}</span>
                ) : (
                  allLabels.map((item, index) => (
                    <span key={index}>
                      {item}
                      {index <
                        allLabels.length - GlobalConfiguration.lengthCheckOne &&
                        ", "}
                    </span>
                  ))
                )}
              </p>

              <p className="text-text-secondary text-font-xs font-normal">
                {globalText?.LABELS}
              </p>
            </div>
          </div>
        </CommonLayout>
        {!props?.isReminderFlow && (
          <div className="h-mobile-create-header w-width-full Qmd:hidden block"></div>
        )}
      </div>
    </>
  );
};

export default BeneTransactionStepConfirm;
